import { Injectable, inject } from '@angular/core';
import { Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UsuarioService } from '../services/auth/usuario.service';
import { CustomMessageService } from '../services/utils/message.service';
import { obtenerObjDeJSON } from '../utils/object-utils';

@Injectable({ providedIn: 'root' })
export class AdminGuard {
  private router = inject(Router);
  private usuarioService = inject(UsuarioService);
  private messageService = inject(CustomMessageService);

  canActivate(_route: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    const validSession = this.usuarioService.verificarCaducudadToken();
    const userJson = localStorage.getItem('usuario');

    if (!validSession || !userJson) {
      this.usuarioService.logout();
      this.messageService.alert('La sesión ha caducado. Inicia sesión de nuevo.');
      return this.router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
    }

    const user = obtenerObjDeJSON(userJson);
    if (user?.rol === 'ADMIN') return true;

    this.messageService.alert('Esta sección está reservada a administradores');
    return this.router.createUrlTree(['/admin/operativa']);
  }
}
